import { TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

export default function EnhancedTableHead(props) {
	const createSortHandler = (property) => (event) => {
		props.onRequestSort(event, property);
	};

	const theme = useTheme();
	const { t } = useTranslation();

	return (
		<TableHead>
			<TableRow
				sx={{
					borderRadius: "10px",
					bgcolor: theme.palette.background.default,
				}}
			>
				<TableCell
					sortDirection={
						props.orderBy === "createdAt" ? props.order : false
					}
				>
					<TableSortLabel
						active={props.orderBy === "date"}
						direction={
							props.orderBy === "date" ? props.order : "asc"
						}
						onClick={createSortHandler("date")}
					>
						{t("date")}
					</TableSortLabel>
				</TableCell>
				<TableCell
					sortDirection={
						props.orderBy === "description" ? props.order : false
					}
				>
					{t("title")}
				</TableCell>
				<TableCell
					sortDirection={
						props.orderBy === "category" ? props.order : false
					}
				>
					{t("category")}
				</TableCell>
				<TableCell
					sortDirection={
						props.orderBy === "wallet" ? props.order : false
					}
				>
					{t("wallet")}
				</TableCell>
				<TableCell
					align="right"
					sortDirection={
						props.orderBy === "amount" ? props.order : false
					}
				>
					<TableSortLabel
						active={props.orderBy === "amount"}
						direction={
							props.orderBy === "amount" ? props.order : "asc"
						}
						onClick={createSortHandler("amount")}
					>
						{t("amount")}
					</TableSortLabel>
				</TableCell>
			</TableRow>
		</TableHead>
	);
}
